<!--  this component support lazyloading and only accept one single event-id value-->
<template lang="html">
  <div id="vue-gf-event-topfundraisers-leaderboard">
    <!--  Advanced Mode -->
    <div
      v-if="customTemplate"
      class="container"
    >
      <InfiniteScroll :disabled="loading" @load-more="fetchPageAndLoad">
        <div
          v-for="(item, index) in topFundraisersForAllEvents"
          :key="index"
          class="row pointer"
          @click="openPage(item.Url)"
        >
          <slot
            name="customTemplate"
            :page="item"
          >
            Custom Template here
          </slot>
        </div>
      </InfiniteScroll>
    </div>

    <!-- Classic Mode -->
    <div v-if="!customTemplate">
      <LeaderboardItems
        :items="leaderboardItems"
        :title="title"
        :sort-by="pageSortBy"
        :widget-template="widgetTemplate"
        :region-code="pageRegionCode"
        :disable-infinite-scroll="disableInfiniteScroll"
        :show-donate="showDonate"
        :show-title="showTitle"
        :show-event-name="showEventName"
        :show-load-more="showLoadMore"
        :show-spinner="loading"
        :settings="settings"
        @loadMore="lazyLoading"
      />
    </div>
  </div>
</template>

<script>
import "promise-polyfill/src/polyfill";
import constants from "../common/constants";
import LeaderboardItems from "./Shared/LeaderboardItems.vue"
import TemplatedLeaderboard from "./Shared/TemplatedLeaderboard.vue"
import getEventsTopFundraisersData from "../data/getEventsTopFundraisersData.json";
import gfApiServices from "@gf/gf-api-services"
import GfUtility from "@gf/gf-utility";
import InfiniteScroll from '../components/InfiniteScroll.vue'

export default {
	name: "EventsTopFundraisers",
	components: { LeaderboardItems, InfiniteScroll },
	mixins: [TemplatedLeaderboard],

	data: function () {
		return {
			topFundraisersForAllEvents: []
		};
	},
	computed: {
		leaderboardItems() {
			return this.topFundraisersForAllEvents.map(i => {
				return {
					url: i.Url,
					donateUrl: i.DonateUrl,
					imagePath: i.ImagePath,
					title: i.LeaderboardTitle,
					eventName: i.Event.EventName,
					driverButtonBgColour: i.Event.EventTheme.DriverButtonBackgroundColour,
					activityData: {
						totalStepInNumber: i.ActivityData.TotalStepInNumber,
						totalDistanceInMeters: i.ActivityData.TotalDistanceInMeters,
						totalTimeInMinutes: i.ActivityData.TotalTimeInMinutes,
						totalEnergyInCalories: i.ActivityData.TotalEnergyInCalories
					},
					total: i.Total,
					hierarchyTotal: i.TeamRaisedTotal,
					currencySymbol: i.CurrencySymbol,
					creatorName:i.CreatorName,
					message:i.Message, 
					pageTitle: i.PageTitle
				}
			});
		},

		customTemplate() {
			return typeof this.$slots.customTemplate !== 'undefined' 
        ? this.$slots.customTemplate()
        : null
		}
	},

	mounted() {
		this.$nextTick(async () => {
      await this.fetchPageAndLoad();
    })
	},

	methods: {
		async lazyLoading() {
			if (!this.morePages)
				return;

			this.loading= true;
			var results = await this.populateLeaderBoard(this.currentPage);

			results.Pages.forEach((o) => {
				this.topFundraisersForAllEvents.push(o);
			});

      		this.topFundraisersForAllEvents.concat(
				results.Pages
			);
			this.loading= false;
			this.morePages = this.isMoreDataAvailable(results);

			this.currentPage += 1;
		},
		async fetchPageAndLoad() {
			if (!this.morePages) {
				return;
			}

			this.loading = true;
			var results = await this.populateLeaderBoard(this.currentPage);

			results.Pages.forEach((o) => {
				this.topFundraisersForAllEvents.push(o);
			});

			this.topFundraisersForAllEvents.concat(results.Pages);
			this.loading = false;

			if(this.settings.loadMoreOption === constants.LOAD_MORE_OPTION_FIXED) {
				this.morePages = false;
			}
			else {
				this.morePages = this.isMoreDataAvailable(results);
				this.currentPage += 1;
			}
		},


		async populateLeaderBoard(pageIndex) {

			if (this.isDemoMode) {
				var chunkSize = this.size;
				if(chunkSize >20) chunkSize = 20;

				var data =Object.assign({}, getEventsTopFundraisersData);
				data.Pages = data.Pages.slice(0, chunkSize);
        		return this.constructTopFundraisers(data);
			}

			if(this.settings.loadMoreOption === constants.LOAD_MORE_OPTION_FIXED && this.size > this.maxSize)
				this.size = this.maxSize;

				var leaderboardMode = this.pageType === constants.FUNDRAISING_PAGE_INDIVIDUAL_TYPE_ID
						? constants.FUNDRAISING_PAGE_INDIVIDUAL_TYPE_ID.toLowerCase()
						: constants.FUNDRAISING_PAGE_TEAM_TYPE_ID.toLowerCase();

				var res = null
				var resCurrency = null
				var eventIds = this.eventIds || [this.eventId] || []
				var topFundraisers = {
					Pages: [],
							ResultsReturned: 0,
							TotalPages: 0,
							PageNumber: 0,
				}
				let sortByParam = constants.FUNDRAISING_PAGE_LEADERBOARD_SORT_BY_TOTAL;

				switch (this.pageSortBy) {
					case constants.FUNDRAISING_PAGE_SORT_BY_TOTAL:
						sortByParam = constants.FUNDRAISING_PAGE_LEADERBOARD_SORT_BY_TOTAL;
						break;

					case constants.FUNDRAISING_PAGE_SORT_BY_TEAM_TOTAL:
						sortByParam = constants.FUNDRAISING_PAGE_LEADERBOARD_SORT_BY_TEAM_TOTAL;
						break;

					default:
						sortByParam = this.pageSortBy;
						break;
				}

				var topFundraisersContructed = topFundraisers				
				var params = {
					eventcampaignid: this.eventId,
					pagetype: leaderboardMode,
					pagesize: this.size,
					pageindex: pageIndex,
					sortorder: this.pageSortOrder,
					sortby: sortByParam,
					tags: this.tags,
					includesubevents: this.settings.includeSubEvents,
					includesubbeneficiaries: this.includeSubBeneficiaries,
					includeparentbeneficiary: this.includeParentBeneficiary,
					includeteammembers: this.settings.includeTeamMembers,
					pageid: this.settings.pageid
				};
				if (this.beneficiaryId && this.beneficiaryId.length > 0)
					params.beneficiaryaccountid = this.beneficiaryId;

				if (eventIds.length > 0) {
					for (var evtKey in eventIds) {
						var eventId = eventIds[evtKey]
						params.eventcampaignid = eventId

						res = await (new gfApiServices.PagesService(this.apiDomain, this.isDemoMode)).byParams(params)					
						resCurrency = await GfUtility.currencyUtility.getCurrencyInfo(this.apiDomain, eventId)
						
						topFundraisersContructed = this.constructTopFundraisers(res, resCurrency);

						topFundraisers.Pages.push(...topFundraisersContructed.Pages)
						topFundraisers.ResultsReturned += topFundraisersContructed.ResultsReturned
						topFundraisers.TotalPages += topFundraisersContructed.TotalPages
						topFundraisers.PageNumber = pageIndex;
					}					
					this.$gfLogger.logInfo('topFundraisers > Multiple event ids', topFundraisers)
					return topFundraisers
				}
				
				res = await (new gfApiServices.PagesService(this.apiDomain, this.isDemoMode)).byParams(params)
				resCurrency = await GfUtility.currencyUtility.getCurrencyInfo(this.apiDomain, this.eventId)
				return this.constructTopFundraisers(res, resCurrency);
		},

		constructTopFundraisers(data, resultCurrency) {
			var topFundraisers = [];

			data.Pages.forEach((elem, index) => {
				var teamRaisedTotal =
					elem.PageType == constants.FUNDRAISING_PAGE_TEAM_TYPE_ID
						? elem.Team.TeamTotal
						: 0;
				var total = 0;

				switch (this.pageSortBy) {
					case constants.FUNDRAISING_PAGE_SORT_BY_TOTAL:
						total = elem.Total;
						break;
					case constants.FUNDRAISING_PAGE_SORT_BY_TEAM_TOTAL:
						total = teamRaisedTotal;
						break;
					case constants.FUNDRAISING_PAGE_SORT_BY_TOTAL_STEP:
						total = elem.ActivityData.TotalStepInNumber;
						break;
					case constants.FUNDRAISING_PAGE_SORT_BY_TOTAL_DISTANCE:
						total = elem.ActivityData.TotalDistanceInMeters;
						break;
					case constants.FUNDRAISING_PAGE_SORT_BY_TOTAL_TIME:
						total = elem.ActivityData.TotalTimeInMinutes;
						break;
					case constants.FUNDRAISING_PAGE_SORT_BY_TOTAL_ENERGY:
						total = elem.ActivityData.TotalEnergyInCalories;
						break;
				}

				elem = Object.assign(elem, {
					TotalRaw: total,
					TeamRaisedTotal: teamRaisedTotal.toString(),
					LeaderboardTitle:
						elem.PageType == constants.FUNDRAISING_PAGE_TEAM_TYPE_ID
							? elem.PageTitle
							: elem.CreatorName,
					CurrencySymbol: resultCurrency != null && typeof resultCurrency.symbol != 'undefined' ? 
							resultCurrency.symbol : 
							typeof elem.defaults.currency.symbol != 'undefined' ? elem.defaults.currency.symbol : '$'
				});
				topFundraisers.push(elem);
			});

			return {
				Pages: topFundraisers,
				ResultsReturned: data.ResultsReturned,
				TotalPages: data.TotalPages,
				PageNumber: data.PageNumber,
			};
		},

		openPage(pageUrl) {
			window.location = pageUrl;
		},
	},
};
</script>